import styled from "@emotion/styled";
import { Padding } from "../sizes/sizes";

export const StandardCardContentContainer = styled.div({
    paddingLeft: Padding.desktop.large,
    paddingRight: Padding.desktop.large,
    paddingTop: Padding.desktop.normal,
})